import { render, staticRenderFns } from "./IndexTableCell.vue?vue&type=template&id=710a8643&scoped=true"
import script from "./IndexTableCell.vue?vue&type=script&lang=js"
export * from "./IndexTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710a8643",
  null
  
)

export default component.exports